import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataShareEducationalProvider, DataShareExplorationSurvey, DataShareProvider } from '@edassist/api';
import { DataShareMarketPlaceSurvey } from '../../models/data-share-provider/data-share-provider.interface';

@Injectable({
	providedIn: 'root'
})
export class ProviderCourseService {
	constructor(private readonly http: HttpClient) {}

	getDataShareProvider(): Observable<DataShareProvider> {
		return this.http.get<DataShareProvider>(`data-share-providers`);
	}

	getDataShareProviders(educationalProviderCode?: string): Observable<Array<DataShareProvider>> {
		let params = new HttpParams();
		if (educationalProviderCode) {
			params = params.append('educationalProviderCode', educationalProviderCode);
		}

		return this.http.get<Array<DataShareProvider>>(`data-share-providers`,
			{
				params: params
			}
		);
	}

	addDataShareProviders(
		payload: DataShareProvider
	): Observable<DataShareProvider> {
		return this.http.post<DataShareProvider>('data-share-providers', payload);
	}

	updateDataShareProvider(
		payload: DataShareProvider
	): Observable<DataShareProvider> {
		return this.http.put<DataShareProvider>(
			`data-share-providers/${payload.id.toString()}`,
			payload
		);
	}

	deleteDataShareProvider(id: string): Observable<void> {
		return this.http.delete<void>(`data-share-providers/${id.toString()}`);
	}

	isDataShareProviderDeletionAllowed(id: string): Observable<boolean> {
		return this.http.get<boolean>(`data-share-providers/${id.toString()}`);
	}

	getDataShareEducationalProvider(educationalProviderCode: string): Observable<DataShareEducationalProvider> {
		return this.http.get<DataShareEducationalProvider>(
			`data-share-providers/education-providers/${educationalProviderCode}`);
	}

	deleteDataShareEducationalProvider(educationalProviderCode: string): Observable<void> {
		return this.http.delete<void>(
			`data-share-providers/education-providers/${educationalProviderCode}`);
	}

	saveDataShareEducationalProvider(dataShareEducationalProvider: DataShareEducationalProvider): Observable<void> {
		return this.http.post<void>(
			`data-share-providers/education-providers`,
			dataShareEducationalProvider
		);
	}

	updateDataShareEducationalProvider(educationalProviderCode: string, dataShareEducationalProvider: DataShareEducationalProvider): Observable<void> {
		return this.http.put<void>(
			`data-share-providers/education-providers/${educationalProviderCode}`,
			dataShareEducationalProvider
		);
	}

	createExplorationSurvey(participantId: number, survey: DataShareExplorationSurvey): Observable<void> {
		return this.http.post<void>(`data-share-providers/participants/${participantId}/program-exploration-survey`, survey);
	}

	registerParticipant(providerId: string, participantId: number): Observable<void> {
		return this.http.post<void>(`data-share-providers/${providerId}/participants?participantId=${participantId}`, {});
	}

	getParticipantMarketPlaceData(dataShareProviderId: string, participantId: number): Observable<Array<DataShareMarketPlaceSurvey>> {
		return this.http.get<Array<DataShareMarketPlaceSurvey>>(`data-share-providers/${dataShareProviderId}/participants/${participantId}/program-interests`);
	}
}
